import Vue from 'vue'
import VueRouter from 'vue-router'

/* User Page */
import UserLayout from '@/views/homepage/UserLayout.vue'

/* Admin Page */
import MainLayout from '@/views/admin/MainLayout.vue'

Vue.use(VueRouter)

function lazyLoad(view) {
  return () => import(`@/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: UserLayout,
    meta: {
      title: 'Trang chủ'
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: lazyLoad('views/homepage/Home'),
        meta: {
          title: 'Hồ sơ'
        }
      },
      {
        path: '/document',
        name: 'DocumentDetail',
        component: lazyLoad('views/document/DocumentDetail'),
        meta: {
          title: 'Hồ sơ'
        }
      },
      {
        path: '/privacypolicy',
        name: 'Privacy Policies',
        component: lazyLoad('views/homepage/PrivacyPolicy'),
        meta: {
          title: 'Hồ sơ'
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: lazyLoad('views/Profile'),
        meta: {
          title: 'Thông tin cá nhân'
        }
      },
      {
        path: '/surveys',
        name: 'StudentSurveys',
        component: lazyLoad('modules/survey-student/SurveyList'),
        meta: {
          title: 'Phiếu khảo sát',
          auth: true
        }
      },
      {
        path: '/surveys/:id',
        name: 'StudentSurveyDetail',
        component: lazyLoad('modules/survey-student/SurveyDetail'),
        meta: {
          title: 'Thực hiện khảo sát',
          auth: true
        }
      }
    ]
  },
  {
    path: '/admin/signin',
    component: lazyLoad('views/admin/AdminSigninDialog'),
    meta: {
      title: 'Đăng nhập'
    }
  },
  {
    path: '/admin',
    component: MainLayout,
    meta: {
      title: 'Trang chủ'
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: lazyLoad('views/admin/Dashboard'),
        meta: {
          title: 'Trang chủ',
          auth: true
        }
      },
      {
        path: 'dashboard-chart',
        name: 'Dashboard chart',
        component: lazyLoad('views/admin/DashboardChart'),
        meta: {
          title: 'Biểu đồ báo cáo',
          auth: true
        }
      },
      {
        path: 'accountdetail',
        name: 'Account Detail',
        component: lazyLoad('views/admin/AccountDetail'),
        meta: {
          title: 'Thông tin tài khoản',
          auth: true
        }
      },
      {
        path: 'user',
        name: 'User Management',
        component: lazyLoad('views/admin/UserManagement'),
        meta: {
          title: 'Quản lý tài khoản',
          auth: true
        }
      },
      {
        path: 'active-code',
        name: 'Active Code',
        component: lazyLoad('modules/active-code/ActiveCode'),
        meta: {
          title: 'Quản lý mã hồ sơ',
          auth: true
        }
      },
      {
        path: 'document',
        name: 'Document',
        component: lazyLoad('modules/cv/admin/Document'),
        meta: {
          title: 'Quản lý hồ sơ',
          auth: true
        }
      },
      {
        path: 'document-cancel',
        name: 'DocumentCancel',
        component: lazyLoad('modules/cv/admin/DocumentCancel'),
        meta: {
          title: 'Hồ sơ đã hủy',
          auth: true
        }
      },
      {
        path: 'document-enroll-cancel',
        name: 'DocumentCancel',
        component: lazyLoad('modules/cv/admin/DocumentEnrollCancel/index'),
        meta: {
          title: 'Đơn hủy nhập học',
          auth: true
        }
      },
      {
        path: 'submit-document',
        name: 'DocumentSubmit',
        component: lazyLoad('modules/cv/admin/DocumentSubmit'),
        meta: {
          title: 'Nộp hồ sơ gốc',
          auth: true
        }
      },
      {
        path: 'enroll-forms',
        name: 'EnrollFormManagementPage',
        component: lazyLoad('modules/enroll-form/EnrollFormManagementPage'),
        meta: {
          title: 'Quản lý đơn nhập học',
          auth: true
        }
      },
      {
        path: 'grade6-enroll-forms',
        name: 'Grade6EnrollFormPage',
        redirect: {name: 'EnrollFormManagementPage', query: {grade: '6'}},
        meta: {
          title: 'Đơn đăng ký khối 6',
          auth: true
        }
      },
      {
        path: 'grade1-enroll-forms',
        name: 'Grade1EnrollFormPage',
        redirect: {name: 'EnrollFormManagementPage', query: {grade: '1'}},
        meta: {
          title: 'Đơn nhập học Khối 1',
          auth: true
        }
      },
      {
        path: 'grade1-class-assignment',
        name: 'Grade1ClassAssignment',
        component: lazyLoad('modules/enroll-form/Grade1ClassAssignment'),
        meta: {
          title: 'Quản lý xếp lớp Khối 1',
          auth: true
        }
      },
      {
        path: 'grade10-enroll-forms',
        name: 'Grade10EnrollFormPage',
        redirect: {name: 'EnrollFormManagementPage', query: {grade: '10'}},
        meta: {
          title: 'Đơn đăng ký khối 10',
          auth: true
        }
      },
      {
        path: 'grade1-result',
        name: 'Grade1ExamResult',
        component: lazyLoad('modules/cv/admin/Grade1ExamResult'),
        meta: {
          title: 'Kết quả đánh giá Khối 1',
          auth: true
        }
      },
      {
        path: 'grade6-result',
        name: 'Grade6ExamResult',
        component: lazyLoad('modules/cv/admin/Grade6ExamResult'),
        meta: {
          title: 'Kết quả thi Khối 6',
          auth: true
        }
      },
      {
        path: 'grade10-result',
        name: 'Grade10ExamResult',
        component: lazyLoad('modules/cv/admin/Grade10ExamResult'),
        meta: {
          title: 'Kết quả thi Khối 10',
          auth: true
        }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: lazyLoad('views/admin/Statistics'),
        meta: {
          title: 'Thống kê',
          auth: true
        }
      },
      {
        path: 'notification',
        name: 'Notification',
        component: lazyLoad('modules/notification/index'),
        meta: {
          title: 'Gửi thông báo',
          auth: true
        }
      },
      {
        path: 'lead',
        name: 'Lead',
        component: lazyLoad('modules/lead/LeadPage'),
        meta: {
          title: 'Lead',
          auth: true
        }
      },
      {
        path: 'lead/:id',
        name: 'Lead details',
        component: lazyLoad('modules/lead/leadDetails/LeadDetails'),
        meta: {
          title: 'Thông tin Lead',
          auth: true
        }
      },
      {
        path: 'sale',
        name: 'Sale users',
        component: lazyLoad('modules/user/sale/UserPage'),
        meta: {
          title: 'Nhân viên sale',
          auth: true
        }
      },
      {
        path: 'sale/:id',
        name: 'Sale details',
        component: lazyLoad('modules/user/sale/SaleDetails'),
        meta: {
          title: 'Nhân viên sale',
          auth: true
        }
      },
      {
        path: 'product',
        name: 'Product',
        component: lazyLoad('modules/product/product/ProductPage'),
        meta: {
          title: 'Hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'product/:id',
        name: 'Product details',
        component: lazyLoad('modules/product/product/ProductDetails'),
        meta: {
          title: 'Hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'report',
        name: 'Lead report',
        component: lazyLoad('modules/report/LeadReport'),
        meta: {
          title: 'Báo cáo CRM',
          auth: true
        }
      },
      {
        path: 'sms',
        name: 'Send SMS',
        component: lazyLoad('modules/sms/SmsPage'),
        meta: {
          title: 'Tin nhắn SMS',
          auth: true
        }
      },
      {
        path: 'email',
        name: 'Send Email',
        component: lazyLoad('modules/email/EmailPage'),
        meta: {
          title: 'Email',
          auth: true
        }
      },
      {
        path: 'policies',
        name: 'Role policies',
        component: lazyLoad('modules/policy/PolicyConfig'),
        meta: {
          title: 'Phân quyền',
          auth: true
        }
      },
      {
        path: 'users-management',
        name: 'List Users',
        component: lazyLoad('views/admin/ListUserManagement'),
        meta: {
          title: 'Danh sách người dùng',
          auth: true
        }
      },
      {
        path: 'exams',
        name: 'Exams',
        component: lazyLoad('modules/exam/ExamPage'),
        meta: {
          title: 'Kỳ thi',
          auth: true
        }
      },
      {
        path: 'exams/:id',
        name: 'Exam details',
        component: lazyLoad('modules/exam/ExamDetailsPage'),
        meta: {
          title: 'Kỳ thi',
          auth: true
        }
      },
      {
        path: 'exam-registration-rounds',
        name: 'Exam Registration Rounds',
        component: lazyLoad('modules/exam-round/ExamRegistrationRoundPage'),
        meta: {
          title: 'Đợt đăng ký dự thi',
          auth: true
        }
      },
      {
        path: 'students',
        name: 'Students list',
        component: lazyLoad('modules/student/StudentPage'),
        meta: {
          title: 'Học sinh',
          auth: true
        }
      },
      {
        path: 'markInput',
        name: 'Mark input',
        component: lazyLoad('modules/grade/MarkPage'),
        meta: {
          title: 'Nhập điểm',
          auth: true
        }
      },
      {
        path: 'markView',
        name: 'Mark input',
        component: lazyLoad('modules/grade/MarkViewPage'),
        meta: {
          title: 'Nhập điểm',
          auth: true
        }
      },
      {
        path: 'student-review',
        name: 'Student Review',
        component: lazyLoad('views/admin/StudentReview'),
        meta: {
          title: 'Danh sách phúc khảo',
          auth: true
        }
      },
      {
        path: 'teachers',
        name: 'Teachers Page',
        component: lazyLoad('modules/grade/TeachersPage'),
        meta: {
          title: 'Giáo viên',
          auth: true
        }
      },
      {
        path: 'teacherAssign',
        name: 'Teachers Assign',
        component: lazyLoad('modules/grade/TeacherAssignPage'),
        meta: {
          title: 'Phân công',
          auth: true
        }
      },
      {
        path: 'monitorAssign',
        name: 'Monitor Assign',
        component: lazyLoad('modules/monitor/MonitorAssignPage'),
        meta: {
          title: 'Phân công',
          auth: true
        }
      },
      {
        path: 'absent',
        name: 'Absent List',
        component: lazyLoad('modules/absent-list/AbsentPage'),
        meta: {
          title: 'Biên bản thi',
          auth: true
        }
      },
      {
        path: 'code',
        name: 'Code Config',
        component: lazyLoad('modules/code-config/CodePage'),
        meta: {
          title: 'Số túi và mã phách',
          auth: true
        }
      },
      {
        path: 'event',
        name: 'Event',
        component: lazyLoad('views/admin/Event'),
        meta: {
          title: 'Sự kiện',
          auth: true
        }
      },
      {
        path: 'interviews',
        name: 'Interview Management',
        component: lazyLoad('modules/interview/admin/InterviewManagement'),
        meta: {
          title: 'Phỏng vấn học bổng',
          auth: true
        }
      },
      {
        path: 'setting-banner',
        name: 'Setting Banner',
        component: lazyLoad('modules/page-settings/BannerSetting'),
        meta: {
          title: 'Cấu hình anner',
          auth: true
        }
      },
      {
        path: 'setting-popup',
        name: 'Setting Popup',
        component: lazyLoad('modules/page-settings/PopupSetting'),
        meta: {
          title: 'Cấu hình popup',
          auth: true
        }
      },
      {
        path: 'bulletin-6',
        name: 'Setting Bulletin 6',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Thông tin tuyển sinh 6',
          auth: true
        }
      },
      {
        path: 'bulletin-1',
        name: 'Setting Bulletin 1',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Thông tin tuyển sinh 1',
          auth: true
        }
      },
      {
        path: 'bulletin-10',
        name: 'Setting Bulletin 10',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Thông tin tuyển sinh 10',
          auth: true
        }
      },
      {
        path: 'instruction-6',
        name: 'Instruction 6',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Hướng dẫn tuyển sinh 6',
          auth: true
        }
      },
      {
        path: 'instruction-1',
        name: 'Instruction 1',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Hướng dẫn tuyển sinh 1',
          auth: true
        }
      },
      {
        path: 'instruction-10',
        name: 'Instruction 10',
        component: lazyLoad('modules/page-settings/InstructionPage'),
        meta: {
          title: 'CH Hướng dẫn tuyển sinh 10',
          auth: true
        }
      },
      {
        path: 'enroll-news',
        name: 'Enroll News',
        component: lazyLoad('views/news/NewsManagement'),
        meta: {
          title: 'QL Tin tức',
          auth: true
        }
      },
      {
        path: 'display-setting',
        name: 'Display Setting',
        component: lazyLoad('views/admin/DisplaySetting'),
        meta: {
          title: 'Cài đặt hiển thị',
          auth: true
        },
      },
      {
        path: 'direct-admissions-grade1',
        name: 'Direct Admission Grade 1',
        component: lazyLoad('modules/direct-admission/DirectAdmissionPage'),
        props: {grade: 'Khối 1'},
        meta: {
          title: 'Xét duyệt tuyển thẳng khối 1',
          auth: true,
        },
      },
      {
        path: 'direct-admissions-grade6',
        name: 'Direct Admission',
        component: lazyLoad('modules/direct-admission/DirectAdmissionPage'),
        props: {grade: 'Khối 6'},
        meta: {
          title: 'Xét duyệt tuyển thẳng khối 6',
          auth: true,
        },
      },
      {
        path: 'direct-admissions-grade10',
        name: 'Direct Admission',
        component: lazyLoad('modules/direct-admission/grade10/DirectAdmissionTableGrade10'),
        meta: {
          title: 'Xét duyệt tuyển thẳng khối 10',
          auth: true,
        },
      },
      {
        path: 'admission-review',
        name: 'Admission Review',
        component: lazyLoad('modules/admission-review/AdmissionReview'),
        meta: {
          title: 'Xét duyệt nhập học',
          auth: true
        }
      },
      {
        path: 'update-expectation',
        name: 'Edit Expectation',
        component: lazyLoad('modules/expectation/EditExpectation'),
        meta: {
          title: 'Chỉnh sửa hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'enroll-slot-review',
        name: 'Enroll Slot Review',
        component: lazyLoad('modules/enroll-slot-review/EnrollSlotReview'),
        meta: {
          title: 'Phê duyệt chỉnh sửa hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'enroll-service',
        name: 'Enroll Service',
        component: lazyLoad('modules/enroll-service/EnrollService'),
        meta: {
          title: 'Phê duyệt chỉnh sửa hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'online-enrollment',
        name: 'Online Enrollment',
        component: lazyLoad('modules/online-enrollment/OnlineEnrollment'),
        meta: {
          title: 'Nhập học trực tuyến',
          auth: true
        }
      },
      {
        path: 'display-setting-result-exam',
        name: 'Display Setting Result Exam',
        component: lazyLoad('modules/display-setting-result/DisplaySettingResultExam'),
        meta: {
          title: 'Cài đặt hiển thị kết quả nhập học',
          auth: true
        }
      },
      {
        path: 'display-setting-step',
        name: 'Display Setting Step',
        component: lazyLoad('modules/display-setting-step/DisplaySettingStep'),
        meta: {
          title: 'Cài đặt hiển thị các bước nhập học',
          auth: true
        }
      },
      {
        path: 'enrollment-window',
        name: 'Enrollment Window',
        component: lazyLoad('modules/enrollment-window/EnrollmentWindowPage'),
        meta: {
          title: 'Lịch mở nhập học theo diện',
          auth: true
        }
      },
      {
        path: 'incentive-review',
        name: 'Incentive Review',
        component: lazyLoad('modules/incentive-reference/IncentiveReviewPage'),
        meta: {
          title: 'QL Xét duyệt ưu đãi',
          auth: true
        }
      },
      {
        path: 'preschool-review',
        name: 'Preschool Review',
        component: lazyLoad('modules/preschool-review/PreschoolReviewPage'),
        meta: {
          title: 'QL Xét duyệt học sinh mầm non Khối 1',
          auth: true
        }
      },
      {
        path: 'direct-admission-review',
        name: 'Direct Admission Review',
        component: lazyLoad('modules/direct-admission-review/DirectAdmissionReviewPage'),
        meta: {
          title: 'QL Xét duyệt tuyển thẳng',
          auth: true
        }
      },

      {
        path: 'incentive-references',
        name: 'Incentive References',
        component: lazyLoad('modules/incentive-reference/IncentiveReferencePage'),
        meta: {
          title: 'QL thông tin ACE',
          auth: true
        }
      },
      {
        path: 'invoice-list',
        name: 'Invoice List',
        component: lazyLoad('modules/invoice/InvoicePage'),
        meta: {
          title: 'QL hoá đơn',
          auth: true
        }
      },
      {
        path: 'cash-payment',
        name: 'Cash Payment',
        component: lazyLoad('modules/cash-payment/CashPaymentPage'),
        meta: {
          title: 'Thu tiền mặt',
          auth: true
        }
      },
      {
        path: 'application-fee',
        name: 'Application Fee',
        component: lazyLoad('modules/application-fee/ApplicationPage'),
        meta: {
          title: 'CH Phí mở hồ sơ',
          auth: true
        }
      },
      {
        path: 'product-fees',
        name: 'Product Fees',
        component: lazyLoad('modules/product/product/ProductFeePage'),
        meta: {
          title: 'CH Phí hệ đào tạo',
          auth: true
        }
      },
      {
        path: 'enroll-capacity',
        name: 'Enrollment Capacity',
        component: lazyLoad('modules/enroll-capacity/EnrollCapacityPage'),
        meta: {
          title: 'Lịch mở nhập học theo diện',
          auth: true
        }
      },
      {
        path: 'document-template',
        name: 'Document Template',
        component: lazyLoad('modules/document-template/DocumentTemplatePage'),
        meta: {
          title: 'Chỉnh sửa mẫu hồ sơ',
          auth: true
        }
      },
      {
        path: 'admission-config',
        name: 'Admission Config',
        component: lazyLoad('modules/admission-config/AdmissionConfig'),
        meta: {
          title: 'Cấu hình trúng tuyển',
          auth: true
        }
      },
      {
        path: 'annual-report',
        name: 'Annua Report',
        component: lazyLoad('modules/annual-report/AnnualReport'),
        meta: {
          title: 'Báo cáo theo năm',
          auth: true
        }
      },
      {
        path: 'pdf-template',
        name: 'PDF Template',
        component: lazyLoad('modules/pdf-template/PDFTemplatePage'),
        meta: {
          title: 'Quản lý mẫu file pdf',
          auth: true
        }
      },
      {
        path: 'admission-method',
        name: 'Admission Method',
        component: lazyLoad('modules/admission-method/AdmissionMethodPage'),
        meta: {
          title: 'Quản lý phương thức tuyển sinh',
        },
      },
      {
        path: 'appointment',
        name: 'Appointment',
        component: lazyLoad('modules/send-appointment/AppointmentPage'),
        meta: {
          title: 'QL Gửi giấy hẹn',
          auth: true
        }
      },
      {
        path: 'survey-form',
        name: 'survey-form',
        component: lazyLoad('modules/survey-form/SurveyForm'),
        meta: {
          title: 'Quản lý phiếu khảo sát',
          auth: true
        }
      },
      {
        path: 'survey-form/:id',
        name: 'survey-detail',
        component: lazyLoad('modules/survey-form/SurveyDetail'),
        meta: {
          title: 'Chi tiết phiếu khảo sát',
          auth: true
        }
      },
      {
        path: 'admission-formula',
        name: 'Admission Formula',
        component: lazyLoad('modules/admission-formula/AdmissionFormulaPage'),
        meta: {
          title: 'Quản lý công thức tuyển sinh',
          auth: true
        }
      },
      {
        path: 'admission-plan',
        name: 'Admission Plan',
        component: lazyLoad('modules/admission-plan/AdmissionPlanPage'),
        meta: {
          title: 'Quản lý điều kiện trúng tuyển',
          auth: true
        }
      },
      {
        path: 'direct-admission-product',
        name: 'Direct Admission Product',
        component: lazyLoad('modules/direct-admission-product/DirectAdmissionProductPage'),
        meta: {
          title: 'Cấu hình hệ tuyển thẳng',
          auth: true
        }
      },
      {
        path: 'admission-variables',
        name: 'Admission Variable',
        component: lazyLoad('modules/admission-variables/AdmissionVariablePage'),
        meta: {
          title: 'Quản lý biến tuyển sinh',
          auth: true
        }
      },
      {
        path: 'admission-evaluation',
        name: 'Admission Evaluation',
        redirect: '/admin/admission-plan'
      },
      {
        path: 'admission-list',
        name: 'Admission List',
        component: lazyLoad('modules/admission-list/AdmissionListPage'),
        meta: {
          title: 'Quản lý danh sách trúng tuyển',
          auth: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
